import { useEffect, useRef } from 'react';
import { useCallbackRef } from './use-callback-ref.js';

export function useCountdownCallback(
  callback: (...args) => void,
  totalSeconds: number,
  options: {
    intervalTime?: number;
  } = {}
) {
  const storedCallback = useCallbackRef(callback);
  const { intervalTime = 1000 } = options;
  const timeLeft = useRef<number>(totalSeconds);
  const timeout = useRef<ReturnType<typeof setTimeout>>();

  const resetTimer = useCallbackRef(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeLeft.current = totalSeconds;
  });

  useEffect(
    () => () => {
      resetTimer();
    },
    [resetTimer]
  );

  const timerInvoker = useCallbackRef(() => {
    storedCallback(timeLeft.current);
    timeout.current = setTimeout(() => {
      if (timeout.current && timeLeft.current <= 0) {
        clearTimeout(timeout.current);
      } else {
        timeLeft.current = timeLeft.current - intervalTime;
        timerInvoker();
      }
    }, intervalTime);
  });

  return useCallbackRef(() => {
    resetTimer();
    timerInvoker();
  });
}
